import React, { FC } from "react";
import { Tabs as MuiTabs } from "@mui/material";
import { styled } from "@mui/material/styles";
import styles from "@/components/anchorData/anchorData.module.css";

interface StyledTabsProps {
  value: string | false;
  onChange: (event: React.SyntheticEvent, newValue: string) => void;
  children: React.ReactNode;
}

const Tabs = styled(MuiTabs)({
  "& .MuiTabs-indicator": {
    backgroundColor: "#8c1ec8",
  },
});

const StyledTabs: FC<StyledTabsProps> = ({ value, onChange, children }) => {
  return (
    <Tabs
      value={value}
      onChange={onChange}
      textColor="inherit"
      className={styles.tabGroup}
    >
      {children}
    </Tabs>
  );
};

export default StyledTabs;
